import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "CertificateManage" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { ref } from 'vue'
import { usePageModal } from '@/hooks/usePageModal'


export default /*#__PURE__*/_defineComponent({
  __name: 'CertificateManage',
  setup(__props) {

const otherInfo = ref({})

const modalTitle = ref('新增')

const newCb = () => {
  modalTitle.value = '新增项目'
}

const editCb = () => {
  modalTitle.value = '编辑项目'
}

const queryParam = {
  name: ''
}

const resetCb = () => {
  return queryParam
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "certificate",
      deleteTip: "确认删除此项目吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData)
    }, null, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "certificate",
      otherInfo: otherInfo.value,
      validOtherInfo: () => true
    }, null, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"])
  ]))
}
}

})